<template>
    <div class="tl email-octopus-form-wrapper">
        
        <!-- <div class="f55 mb3 pb1 db tracked1 black-60">Sign up free and get smart:</div> -->
        <div class="flex flex-none-ns dib w-100 mw55 inputshadow">
            <div id="sk-parent" class="absolute">
                <div class="sk-double-bounce dib">
                    <div class="sk-child sk-double-bounce1 dib"></div>
                    <div class="sk-child sk-double-bounce2 dib"></div>
                </div>
            </div>
            <input v-if="error.length == 0" v-model="email" v-on:keyup="keymonitor" id="email" name="email" type="email" placeholder="Enter email to join..." class="sans-serif w-100 fw4 f4 lh-copy4 black-80 input-reset bgfix-ns bg-black-10 pv3 pv35-ns mb0 border-box bn ph3" autofocus>

            <input v-else v-model="email" v-on:keyup="keymonitor" id="email" name="email" type="email" placeholder="Enter your email..." class="sans-serif w-100 fw4 f4 lh-copy4 black-80 input-reset bgfix-ns bg-black-10 pv3 pv35-ns mb0 border-box bn ph3">

            <button v-on:click="submit()" type="button" id="email-btn" class="f4 fw7 lh-copy4 sans-serif button-reset pv3 pv35-ns ph4 tc bg-black-90 white bn pointer w-auto dib email-submit-btn spacefix">→</button>

        </div>

        <p v-if="error.length > 0" class="f6 email-octopus-error-message red">{{ error }}</p>

        <!--
        <div v-if="desc === 'yes'" id="name-desc" class="f6 lh-copy tracked2 db tl mt45-ns mt4 black-50 pl2 bl bw1 b--black-20 measure">
            <em>“…like a cross between Bogleheads.org and NPR's Planet Money in email form. A much needed antidote to all the  fear-driven clickbait in financial news.” -Rob Mann</em>
        </div>
        -->
    </div>
</template>

<script>
    import 'lodash';
    import request from 'request';
    import util from '../util.js';

    export default {
        props: ['desc'],
        data() {
            return {
                email: "",
                error: ""
            }
        },
        methods: {
            errorExists() {
                if (this.error.length > 0) return true;
                else return false;
            },

            submit() {
                this.error = "";
                $("#sk-parent").css('display', 'inline-block');

                if (util.validEmail(this.email)) {
                    var self = this;
                    var options = {
                        url: process.env.HOME_API + "/api/users/",
                        method: 'POST',
                        json: true,
                        body: {
                            email: this.email,
                            ref: util.getParameterByName("ref")
                        },
                    }

                    request(options, function (error, response, body) {
                        $("#sk-parent").hide();
                        if (_.isUndefined(response)) {
                            self.error = "Server might be down. Please check again later.";
                        } else {
                            if (!_.isUndefined(body.result)) {
                                self.$cookies.set("userEmail", self.email, Infinity);
                                self.$cookies.set("userId", body.result.id, Infinity);
                                window.location.href = "/success/";
                            } else {
                                if (!_.isUndefined(body.error)) {
                                    if (body.error === "Email is already subscribed"){
                                        self.$cookies.set("userEmail", self.email, Infinity);
                                        self.$cookies.set("userId", body.user.user_id, Infinity);
                                        self.$cookies.set("message", "Looks like you've already signed up! Not receiving our emails? Contact us!", 15);
                                        window.location.href = "/ambassador/";
                                    } else {
                                        self.error = body.error
                                    }
                                };
                            }
                        }
                    });
                } else {
                    $("#sk-parent").hide();
                    this.error = "Email invalid, please try again.";
                }
            },

            keymonitor: function(event) {
                if (event.key == "Enter") {
                    this.submit();
                }
            }
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// _vue/components/AddUser.vue